import { BranchesOutlined } from '@ant-design/icons';
import { Spin, Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import {
  ActionKind,
  ActionParamsDefaultHtmlElement,
  ActionParamsLink,
  BaseClickable,
} from 'components/ui/BaseClickable';
import { SpacingRow, SpacingUnit } from 'components/ui/Spacing';
import { TableNavigationController } from 'stores/common/TableController/TableNavigationController';
import { noop } from 'utils/noop';
import { translateApiValue } from 'utils/translateApiValue';

import { TableControllerProps } from '../types';

import { ExpandIcon } from './ExpandIcon';
import s from './NavigationController.module.scss';

const NavigationController: React.FC<
  TableControllerProps<TableNavigationController>
> = ({ record, className, row }) => {
  const isFetching = row?.fetchRowsRequest.loading;

  const isExpandable = record.controllerValue.value.pivot.isActive;

  const clickableAction = React.useMemo(():
    | ActionParamsLink
    | ActionParamsDefaultHtmlElement<any> => {
    if (record.canGoToFlatList && row?.factoryTableStore.callParams) {
      return {
        actionKind: ActionKind.link,
        to: record.computeFlatTableRoute(
          row?.factoryTableStore.callParams.form_id
        ),
      };
    }

    return {
      actionKind: ActionKind.defaultHtmlElement,
      complexOnClick: {
        onClick: noop,
      },
    };
  }, [record, row?.factoryTableStore.callParams]);

  return (
    <BaseClickable
      action={clickableAction}
      withHover={record.canGoToFlatList}
      withCursorPointer={record.canGoToFlatList}
      className={className}
    >
      <SpacingRow hSpacing={SpacingUnit.unit4}>
        <BranchesOutlined className={s.navigationController__icons} />
        <Typography.Text>
          {translateApiValue(record.controllerValue.value.payload)}
        </Typography.Text>
        {isExpandable &&
          (isFetching ? <Spin /> : <ExpandIcon rowEntity={row} />)}
      </SpacingRow>
    </BaseClickable>
  );
};

export default observer(NavigationController);
